import { doGetOld, doPostOld, doPatchOld } from '@/services/api/base'

export const getSetting = async (id: string): Promise<SettingsResponse> => {
  return await doGetOld(`/api/settings/${id}`)
}

export const getSettings = async (): Promise<AppSettingsResponse> => {
  return await doGetOld(`/api/users/settings`)
}

export const createSetting = async (key: string, value: string, apps: string[]): Promise<SaveSettingsResponse> => {
  return await doPostOld(`/api/users/settings`, { key, value, apps })
}

export const updateSetting = async (
  id: string,
  key: string,
  value: string,
  apps: string[]
): Promise<SaveSettingsResponse> => {
  return await doPatchOld(`/api/users/settings/${id}`, { key, value, apps })
}

export const getPublicSettings = async (app: string): Promise<SettingsResponse> => {
  return await doGetOld(`/api/settings/${app}`)
}

export default {
  getSetting,
  getSettings,
  createSetting,
  updateSetting,
  getPublicSettings
}
